import { useQuery } from '@tanstack/react-query';

import { fetchData } from '..';

import { marketingCampaignsQueryKey } from './get-campaigns';

export type GetCampaignPerformanceStatsPayload = {
  MarketingCampaignId: number;
};

export type AttributionStats = {
  Carts: number;
  Customers: number;
  Orders: number;
  TotalRevenue: number;
};

export type AutomatedCampaignPerformanceStats = {
  EmailClickedLink: number;
  EmailDelivered: number;
  EmailDirectAttribution: AttributionStats;
  EmailFailedDeliveries: number;
  EmailOpened: number;
  EmailOpenersInStoreAttribution: AttributionStats;
  EmailOpenersOnlineAttribution: AttributionStats;
  EmailRecipients: number;
  EmailUnsubscribes: number;
  MonthsBack: number;
  PushOpened: number;
  PushOpenersInStoreAttribution: AttributionStats;
  PushOpenersOnlineAttribution: AttributionStats;
  PushRecipients: number;
  SMSClicked: number;
  SMSDelivered: number;
  SMSDirectAttribution: AttributionStats;
  SMSFailedDeliveries: number;
  SMSOpenersInStoreAttribution: AttributionStats;
  SMSOpenersOnlineAttribution: AttributionStats;
  SMSRecipients: number;
  SMSUnsubscribes: number;
  SMSVerified: number;
};

export function useGetAutomatedCampaignsPerformanceStatsQuery({
  MarketingCampaignId,
}: GetCampaignPerformanceStatsPayload) {
  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'get-automated-campaign-performance-v2', MarketingCampaignId],
    queryFn: async () =>
      fetchData<AutomatedCampaignPerformanceStats[]>('api/marketing-campaign/get-automated-campaign-performance-v2', {
        MarketingCampaignId,
      }),
  });
}
